import styled from '@emotion/styled'
import Dialog from '@mui/material/Dialog'
import Button from '@mui/material/Button'
import {DialogTitle} from '@mui/material'
import Box from '@mui/material/Box'

export const StyledModal = styled(Dialog)(({theme}) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2)
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1)
  }
}))

export const StyledCloseButton = styled(Button)(({theme}) => ({
  width: '24px',
  color: theme.palette.grey[700],
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  padding: 0,
  '&:hover': {
    backgroundColor: 'transparent'
  }
}))

export const StyledDialogTitle = styled(DialogTitle)(({theme}) => ({
  margin: 0,
  padding: theme.spacing(2)
}))

export const StyledModalHeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px'
})

export const StyledModalTitleBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingRight: '16px'
})

export const StyledModalSpacer = styled(Box)({
  marginTop: '24px'
})
